import React, {useState} from 'react';
import {Col, DatePicker, Form, Input, Row} from "antd";
import {OfficersFiltersTypes} from "./Officers.filters.types";
import FormLabel from "../../common/Form.label/Form.label";
import NAICSTags from "../NAICS.tags/NAICS.tags";
import PSCTags from "../PSC.tags/PSC.tags";
import Button from "../../common/Button/Button";
import {SearchOutlined} from "@ant-design/icons";
import GeographicalStatesSelect from "../../common/Select.geographicalStates.tsx/Select.geographicalStates";

interface Props {
    onSubmitQuery?: (query:any) => void,
    initialValues?:any
}

function OfficersFilter({onSubmitQuery, initialValues}:Props) {
    const [form] = Form.useForm();
    const [submittingForm, setSubmittingForm] = useState(false);
    //eslint-disable-next-line
    const [valuesForm, setValuesForm] = useState({});

    async function onFinish() {
        if (submittingForm) return false;
        setSubmittingForm(true);
        try {
            let valid = await form.validateFields();
            if (!valid.errorFields && onSubmitQuery) {
                let values = form.getFieldsValue();
                await onSubmitQuery(values);
            }
        } catch (e) {

        }
        setSubmittingForm(false);
    }

    function onValuesChange(v) {
        setValuesForm(v)
    }

    return (
        <div className='opportunities-filters'>
            <Form layout='vertical' form={form} onValuesChange={onValuesChange} onFinish={onFinish} initialValues={initialValues}>
                <Row gutter={16}>
                    <Col span={8}>
                        <FormLabel title='Agency'/>
                        <Form.Item name={OfficersFiltersTypes.Agency}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <FormLabel title='Signed Date'/>
                        <Form.Item name={OfficersFiltersTypes.SignedDate}>
                            <DatePicker.RangePicker size='large' style={{width: '100%'}}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <FormLabel title='PoP State'/>
                        <Form.Item name={OfficersFiltersTypes.PopState}>
                            <GeographicalStatesSelect/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <FormLabel title='Email'/>
                        <Form.Item name={OfficersFiltersTypes.Email}>
                            <Input size='large'/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <FormLabel title='NAICS Codes'/>
                        <Form.Item name={OfficersFiltersTypes.Naics}>
                            <NAICSTags/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <FormLabel title='PSC Codes'/>
                        <Form.Item name={OfficersFiltersTypes.PscCode}>
                            <PSCTags/>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button htmlType='submit' icon={<SearchOutlined/>} iconPosition='left' loading={submittingForm}>
                        Search
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default OfficersFilter;